// filepath: apps/web/src/features/admin/audit/AuditViewerRoute.tsx
//
// FR-UI-ADM-14 — Route shell for /admin/audit.

import { useTranslation } from "@/i18n/useTranslation";
import { AuditViewerPage } from "./AuditViewerPage";

export function AuditViewerRoute() {
  const { locale } = useTranslation();
  return <AuditViewerPage locale={locale} />;
}
